import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { ConfirmationDialogComponent } from 'spotlight-ui/app/shared/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'reassign-input-dialog',
  templateUrl: './reassign-input-dialog.component.html',
  styleUrls: ['./reassign-input-dialog.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatIconModule,
    MatButtonModule,
    FlexLayoutModule
  ]
})

export class ReassignInputDialogComponent implements OnInit {

  public name: string;
  public isMobile: boolean;
  public reassignForm: FormGroup;
  public submitted: boolean = false;
  public readonly reassignFieldMaxLength = 4000;

  constructor(
    private readonly fb: FormBuilder,
    private readonly dialog: MatDialog,
    public readonly dialogRef: MatDialogRef<ReassignInputDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: any
  ) {
    this.name = data.name;
    this.isMobile = data.isMobile;
  }

  public ngOnInit() {
    this.reassignForm = this.fb.group({
      reassignReason: ['', [Validators.required, Validators.maxLength(this.reassignFieldMaxLength)]],
      isCustomerContacted: [null, Validators.required],
      reassignLocation: ['', Validators.maxLength(this.reassignFieldMaxLength)]
    });
  }

  public onReassignClicked() {
    this.reassignForm.markAllAsTouched();
    this.submitted = true;

    if (this.reassignForm.invalid) {
      return;
    }

    let config = new MatDialogConfig();

    config.data = {
      title: 'Confirm Reassignment',
      displayText: 'Are you sure you want to reassign this case?',
      confirmText: 'Confirm',
      cancelText: 'Back'
    };

    this.dialog.open(ConfirmationDialogComponent, config)
      .afterClosed()
      .subscribe((confirm) => {
        if (confirm) {
          this.dialogRef.close(this.reassignForm.value);
        }
      });
  }

  public onCancel() {
    this.dialogRef.close();
  }
}